import { PropsWithChildren } from 'react'

type TitleProps = {}

export const Title = ({ children }: PropsWithChildren<TitleProps>) => {
  return <div className="md:text-lg text-sm">{children}</div>
}
